var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinishMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3432,
    cy: 60.3432,
    r: 59.6567,
    fill: "#4A27ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6504 63.1397L47.9145 82.404L92.0357 38.2827",
    stroke: "white",
    strokeWidth: 19.4458,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishMessage);
export default __webpack_public_path__ + "static/media/finishMessage.a2285756bb567d6a2738bad3aa37b132.svg";
export { ForwardRef as ReactComponent };